import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {PaymentMethod} from '../models/PaymentModels';
import {PaymentsService} from '../services/payments.service';
import {combineLatest} from 'rxjs';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.less'],
})
export class AuthComponent implements OnInit, AfterViewInit {
  public userName: string;
  public password: string;
  public forgotPasswordUserName: string;

  public LoginError: boolean;
  public validationMessage: string;
  public redirectRoute: string;

  public showForgotPassword = false;

  constructor(
    private readonly toast: ToastrService,
    private readonly location: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly paymentsService: PaymentsService,
    private readonly auth: AuthService) {
    auth.titleBarText = 'RIQ Login';
  }

  public ngOnInit(): void {

    // const combined = combineLatest([this.auth.userFetchComplete, this.auth.roleFetchComplete]).subscribe((r: any) => {

    //   // Only do the following route if the user is admin or billing admin

    //   // if ((this.auth.UserInRole('Admin') || this.auth.UserInRole('BillingViewer')) && (!this.auth.UserInRole('CRA'))) {

    //   //   const clientId = this.auth.loggedInUser.clientId;

    //   //   combined.unsubscribe();

    //   //   this.paymentsService.FetchPaymentMethods(0, clientId).subscribe((res: PaymentMethod[]) => {
    //   //       if (!res || res.length === 0) {
    //   //         // No payment methods
    //   //         this.routeToPayments(clientId);
    //   //       } else {
    //   //         // Now filter the payments based on isActive
    //   //         const yy = res.filter(w => w.isActive);

    //   //         if (yy.length === 0) {
    //   //           // We do not have any active payments
    //   //           this.routeToPayments(clientId);
    //   //         }
    //   //       }
    //   //     },
    //   //     err => {
    //   //       this.toast.error('There was an error loading your payment methods. please contact support for help.', 'Error Loading Payment Methods');
    //   //     });
    //   // }

    // });
  }

  public routeToPayments(clientId: number): void {
    // this.location.navigateByUrl('/clients/review/' + clientId);
    this.paymentsService.$displayPaymentModal.next(true);
  }

  public ngAfterViewInit(): void {
    document.getElementById('auth-form').addEventListener('keypress', (ev) => {
      if (ev.key === 'Enter') {
        this.continue();
      }
    });
  }

  public update(val: any) {
    if (val.name === 'UserName') {
      this.userName = val.value;
    } else {
      this.password = val.value;
    }
  }

  public continue() {
    this.auth.GetToken(this.userName, this.password).subscribe((rsp: any) => {
        localStorage.setItem('STP-JWT', rsp.jwtToken);
        this.auth.GetLoggedInUser();
        if (this.auth.postLoginRedirect) {
          this.location.navigateByUrl(this.auth.postLoginRedirect);
        } else {
          this.location.navigateByUrl('/dashboard');
        }
      },
      (err: any) => {
        if(err.error.pwResetToken){
          this.location.navigate(['/changePasswordViaToken'], { queryParams: { token: err.error.pwResetToken } });

          // this.location.navigateByUrl(`/changePasswordViaToken/${err.error.pwResetToken}`);
        }else{
          this.LoginError = true;
          this.validationMessage = 'There was an error logging you in.';
        }
      });
  }

  public forgotPassword(): void {
    this.forgotPasswordUserName = '';
    this.showForgotPassword = true;
  }

  public sendPasswordResetLink(): void {
    this.auth.SendForgotPasswordLink(this.forgotPasswordUserName).subscribe(() => {
        this.toast.success('Password update Link sent.', 'Link Sent!');
        this.cancelSendPasswordResetLink();
      },
      () => {
        this.toast.error('There was an error sending your password reset link.', '', {disableTimeOut: true, closeButton: true});

      }
      );
  }

  public cancelSendPasswordResetLink(): void {
    this.showForgotPassword = false;
    this.forgotPasswordUserName = '';
  }
}
